import "./css/SectionHero.css";

import "../../assets/animation/medicine-svg.css";
import { ReactComponent as Health1Svg } from "../../assets/medicine.svg";

function SectionHero() {
  return (
    <section className="section-hero ">
      <div className="container landing-container">
        <div className="left">
          <div className="hero-header">
            <p className="hero-welcome">Welcome to </p>
            <h1>
              Physio<span>Track</span>
            </h1>
          </div>
          <p className="hero-info">
            Take charge of your well-being and unlock a healthier you with
            PhysioTrack. Our comprehensive health tracker app empowers you to
            effortlessly monitor and analyze your vital health data.
          </p>
          <a className="get-started">Get Started</a>
        </div>
        <div className="right">
          <Health1Svg />
        </div>
      </div>
    </section>
  );
}

export default SectionHero;
